import { deleteData, getData, postData, putData } from "./url-request";

export const getNotifications = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  ).toString();
  return getData(`/notification${query ? `?${query}` : ""}`);
};
export const getUnreadNotificationCount = () =>
  getData("/notification/unread-count");
export const markNotificationRead = (id) =>
  postData(`/notification/${id}/read`, {});
export const markAllNotificationsRead = () =>
  postData("/notification/mark-all-read", {});
export const getNotificationPreferences = () =>
  getData("/notification/preferences");
export const saveNotificationPreferences = (values) =>
  putData("/notification/preferences", values);
export const savePushSubscription = (subscription) =>
  postData("/notification/push-subscriptions", subscription);
export const disablePushSubscription = (id) =>
  deleteData(`/notification/push-subscriptions/${id}`);
export const disablePushSubscriptions = () =>
  postData("/notification/push-subscriptions/disable", {});
